<template>
    <div class="card bg-light card-height-100 profile-project-card shadow-none profile-project-primary">
        <div class="card-body">
            <div class="row g-2">
                <div class="col-8"> 
                    <span class="text-muted">Qualification</span>
                    <h6> First School leaving Certificate</h6>
                </div>
                <div class="col-12"> 
                    <span class="text-muted">School name</span>
                    <h6> {{item.school_name}} </h6>
                </div>
                <div class="col-sm-6"> 
                    <span class="text-muted">Duration</span>
                    <h6> {{ $filters.number_format(item.duration)}} yrs </h6>
                </div>
                <div class="col-12">
                    <div class="row g-2">
                        <div class="col-sm-6"> 
                            <span class="text-muted">Start Date</span>
                            <h6> {{ $filters.date(item.start_date)}} </h6>
                        </div>
                        <div class="col-sm-6"> 
                            <span class="text-muted">End Date</span>
                            <h6> {{ $filters.date(item.end_date)}} </h6>
                        </div>
                    </div>
                </div>
                <div class="col-12"> 
                    <span class="text-muted">Remark</span>
                    <h6> {{ item.remark }} </h6>
                </div>
                <div class="col-12 small"> 
                    <div v-if="item.fslc_age_gap > 9" class="alert mb-0 alert-primary">{{ item.fslc_age_gap }}-year age gap between date of birth and FSLC completion.</div>
                    <div v-else class="alert mb-0 alert-danger">FSLC obtained earlier than expected ({{ item.fslc_age_gap }}-year gap).</div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row justify-content-between">
                <div class="col-auto">
                    <button @click.prevent="showProfileImg(item.certificate_path)" class="btn btn-sm btn-soft-primary">View Certificate</button>
                </div>
                <div class="col-auto">
                    <slot name="actions"></slot>
                </div>
            </div>
        </div>
    </div>
    
    </template>
    
    <script>
    export default {
        props:{
            item:{
                type:Object,
                required: true
            }
        }, 
    }
    </script>
    
    <style>
    
    </style>